<template>
  <div class="box" @dragover.prevent @drop.prevent="onDrop">
    <div v-if="!fileUrl" class="upload" @click="open()">
      <iconpark-icon name="plus-circle-fill" class="mb-[12px]" size="32" />
      <a href="javascript:;">{{ $t('dian-ji-huo-tuo-zhuai-wen-jian-dao-ci-chu-shang-chuan') }}</a>
      <div class="tip" v-html="tip"></div>
    </div>
    <template v-else>
      <div
        class="w-full h-[166px] rounded-[8px] flex-y-center overflow-hidden border-dashed border-[1px] border-[var(--purple-4)]"
      >
        <img :src="fileUrl" class="w-full h-full object-contain" loading="lazy" />
      </div>
      <div class="buttons flex-center mt-[40px] mb-[16px] gap-x-[10px] text-[14px]">
        <a-button class="!flex-y-center gap-[3px]" size="large" @click="open()">
          <!-- <img
            :src="UP"
            class="mr-[4px] text-[16px] w-[24px] h-[24px]"
            loading="lazy"
          /> -->
          <iconpark-icon name="up-cloud" size="24"></iconpark-icon>
          {{ $t('zhong-xin-shang-chuan') }}
        </a-button>
        <a-button
          v-show="!isDefault"
          class="!flex-y-center gap-[3px]"
          size="large"
          @click="reset()"
        >
          <!-- <img :src="RESET" class="mr-[4px] text-[16px]" loading="lazy" /> -->
          <iconpark-icon name="reset-circle" size="15"></iconpark-icon>
          {{ $t('hui-fu-mo-ren') }}
        </a-button>
      </div>
    </template>
  </div>
  <div class="p-[20px] flex-center" style="border-top: 1px solid var(--back-4)">
    <a-button
      class="w-[280px]"
      type="primary"
      :disabled="!fileUrl"
      :loading="loading || upLoading"
      @click="handleConfirm"
    >
      {{ $t('que-ding') }}
    </a-button>
  </div>
</template>

<script lang="ts" setup>
/**
 * 个人头像、团队Logo 共用
 */
import type { IResponse } from '~/api/interface';
import { MB_ATOM, transSize, useUpload } from '~/hooks/useUpload';
import { base64ConvertFile } from '~/utils';
// import UP from '~/assets/svg/up.svg?url'
// import RESET from '~/assets/svg/reset.svg?url'

const { $t } = useNuxtApp();

export interface IProps {
  url: string; // 数据回显用
  defaultUrl: string; // 默认图片
  tip: string; // 提示文案
  request(path?: string): Promise<IResponse>; // 保存接口
  success?(data: any): void; // 成功回调，参数为资源对象（如果有）
  cancel(): void; // 关闭弹窗
}

const props = withDefaults(defineProps<IProps>(), {
  success() {
    console.log('success');
  },
});

// const cropper = ref()
const fileUrl = ref<string>(props.url);
const userInfo = useUserInfo();

const isDefault = computed(() => fileUrl.value === props.defaultUrl);

// const preview = reactive({
//   url: '',
//   w: '',
//   h: '',
//   transform: '',
// })
const loading = ref(false);
const accept = ['jpg', 'jpeg', 'png'];

const {
  open,
  onDrop,
  loading: upLoading,
  simpleUpload,
} = useUpload({
  noModal: true,
  accept: `.${accept.join(',.')}`,
  hasMessage: false,
  beforeUpload: file => {
    const suffix = (file.name.split('.').pop() || '').toLowerCase();
    if (!accept.includes(suffix)) {
      message.error($t('qing-shang-chuan-acceptjoin-ge-shi-wen-jian', [accept.join('、')]));
      return false;
    }
    const size = MB_ATOM * 3;
    if (file.size > size) {
      message.error(
        $t('tu-pian-da-xiao-bu-neng-chao-guo-transsizesizemb-dang-qian-transsizefilesizemb', [
          transSize(size),
          transSize(file.size),
        ]),
      );
      return false;
    }
    if (file?.file) {
      getUrl(file?.file);
    }

    return false;
  },
  onSuccess: async (_, res) => {
    loading.value = true;
    try {
      const setRes = await props.request(res.upload_path);
      loading.value = false;
      if (setRes.code !== 0) {
        return;
      }

      message.success($t('she-zhi-cheng-gong'));
      props.success(setRes.data);
      props.cancel();
    } catch (error) {
      console.error(error);

      loading.value = false;
    }
  },
});

const getUrl = async (file: File) => {
  const reader = new FileReader();
  await reader.readAsDataURL(file);
  reader.onload = () => {
    fileUrl.value = reader.result as string;
  };
};

// 提交
const handleConfirm = () => {
  if (fileUrl.value === props.url) {
    props.cancel();
    return;
  }
  if (isDefault.value) {
    resetSubmit();
  } else {
    // 上传了图片，提交
    simpleUpload({ file: base64ConvertFile(fileUrl.value) });
    // fileUrl.value = fileUrl.value
  }
};

// “恢复默认”提交
async function resetSubmit() {
  loading.value = true;
  try {
    const url = new URL(props.defaultUrl);
    const path = url.pathname.replace('/', '');

    const res = await props.request(path);
    if (res.code !== 0) {
      return;
    }

    message.success($t('hui-fu-mo-ren-cheng-gong'));
    props.success(props.defaultUrl);
    props.cancel();
  } catch (err) {
    console.error(err);
  }
}

// const crop = () => {
//   cropper.value.goAutoCrop(260, 260)
//   cropper.value.getCropData((data: string) => {
//     const file = base64ConvertFile(data)
//     simpleUpload({ file })
//   })
// }

// const scale = (n: number) => {
//   cropper.value.changeScale(n * 2)
// }

// const onPreview = (data: any) => {
//   preview.url = data.url
//   preview.w = data.img.width
//   preview.h = data.img.height
//   preview.transform = data.img.transform
// }

// 恢复默认
function reset() {
  fileUrl.value = props.defaultUrl;
}
</script>

<style lang="scss" scoped>
.box {
  @apply w-full relative px-[24px] pt-[90px];
}
.upload {
  @apply mb-[90px] rounded-[8px] w-full h-[166px] bg-back-2 flex-center select-none flex-col cursor-pointer;
  border: 1px dashed var(--back-6);
  &:hover {
    @apply bg-purple-2 border-purple-5;
  }
  a {
    @apply text-14 font-semibold;
  }
  .tip {
    @apply text-12 text-font-50 mt-[6px];
  }
}
.upgradation {
  @apply flex-y-center text-14 font-semibold;
}
.vue-cropper.cropper-area {
  background: white;
  border: 1px dashed var(--back-6);
}
</style>
